<!-- <p class="p2 col-6 left m-b-3 m-t-5-x m-t-5-l w-10 w-12-m w-12-s">
    {{'Please enter your email address to be notified when this product becomes available' | translate}}
</p> -->

<form #form="ngForm"
      method="POST">
    <label class="p1">{{'Email Address' | translate}}:</label>
    <input-wrap>
        <input class="input _inputEmail"
               type="email"
               name="email"
               [placeholder]="'Email Address' | translate"
               maxlength="100"
               [(ngModel)]="data.guest_email"
               (ngModelChange)="onDataChange()"
               validatePattern="email"
               [required]="true"
               email
               (keyup.enter)="submit()"
               cy-subscribeMailInput>
    </input-wrap>
    <action class="button w-12 m-t"
            [ngStyle]="isSuccess ? { 'pointer-events': 'none' } : undefined"
            [status]="status"
            sl-button="subscribe"
            cy-subscribeButton
            (click)="submit()">
        @switch (!isSuccess) {
        @case (false) {
        {{'Thank You' | translate }}
        }
        @default {
        {{'Notify Me When Available' | translate}}
        }
        }
    </action>
</form>

<!-- <p class="c1 italic col-12 left m-t-3">
    <span>{{'By signing up, you are accepting our' | translate}}</span>&nbsp;
    <a routerLink="/privacy-policy"
       target="_blank">{{'Privacy Notice' | translate}}</a>
</p> -->